module.exports = __webpack_public_path__ + "img/p2.25ccff56.png";